/** Central route path registry. Keeps links and guards in sync (spec §36). */
export const paths = {
  // Public / auth
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',

  // Shell
  root: '/',
  dashboard: '/dashboard',

  // Account
  profile: '/account/profile',
  security: '/account/security',
  sessions: '/account/sessions',

  // Modules (routes are added per phase; paths are declared up-front for nav)
  pages: '/website/pages',
  pageBuilder: '/website/pages/:id/builder',
  navigation: '/website/navigation',
  websiteSettings: '/website/settings',
  media: '/media',
  seo: '/seo',

  services: '/content/services',
  industries: '/content/industries',
  solutions: '/content/solutions',
  caseStudies: '/content/case-studies',
  portfolio: '/content/portfolio',
  pricing: '/content/pricing',
  testimonials: '/content/testimonials',
  team: '/content/team',

  blog: '/content/blog',
  resources: '/content/resources',
  tools: '/content/tools',
  faqs: '/content/faqs',
  careers: '/careers',
  forms: '/forms',
  formBuilder: '/forms/:id/builder',
  submissions: '/forms/submissions',

  leads: '/leads',
  crm: '/crm',
  automations: '/automations',
  automationBuilder: '/automations/:id/builder',
  emailTemplates: '/email/templates',
  popups: '/popups',
  booking: '/booking',
  reviews: '/reviews',
  analytics: '/analytics',

  users: '/settings/users',
  roles: '/settings/roles',
  permissions: '/settings/permissions',
  auditLogs: '/settings/audit-logs',
  integrations: '/settings/integrations',
  notifications: '/notifications',
  systemSettings: '/settings/system',

  // Errors
  forbidden: '/403',
  notFound: '/404',
} as const;

export type AppPath = (typeof paths)[keyof typeof paths];
